import { NAME as APP_NAME } from 'constants';
import { getInSeconds } from './utils';

export const NAME = `${APP_NAME}/ADDRESS_BOOK`;
export const LISTING_ENDPOINT = `${SHIPPING_EDGE}/api/address/v3/search`;
export const REDUCER_NAME = 'addressBook';
export const CREATE_FORM_NAME = 'newAddress';
export const EDIT_FORM_NAME = 'updateAddress';

export const ADDRESS_TYPES = [
  {
    type: 'FACILITY',
    description: 'Facility',
    fixedTimeInSec: 901,
    variableTimePerUnitOfMeasureInSecBox: 2,
    variableTimePerUnitOfMeasureInSecPallet: 1201,
    IDK: 1,
  },
  {
    type: 'CUSTOMER',
    description: 'Customer',
    fixedTimeInSec: 905,
    variableTimePerUnitOfMeasureInSecBox: 5,
    variableTimePerUnitOfMeasureInSecPallet: 905,
    IDK: 3,
  },
  {
    type: 'CONSTRUCTION_SITE',
    description: 'Construction Site',
    fixedTimeInSec: 905,
    variableTimePerUnitOfMeasureInSecBox: 5,
    variableTimePerUnitOfMeasureInSecPallet: 905,
    IDK: 3,
  },
  {
    type: 'WAITING_POINT',
    description: 'Waiting Point',
    fixedTimeInSec: 905,
    variableTimePerUnitOfMeasureInSecBox: 5,
    variableTimePerUnitOfMeasureInSecPallet: 905,
    IDK: 3,
  },
  {
    type: 'PLANT',
    description: 'Plant',
    fixedTimeInSec: 905,
    variableTimePerUnitOfMeasureInSecBox: 5,
    variableTimePerUnitOfMeasureInSecPallet: 905,
    IDK: 3,
  },
  {
    type: 'CROSS_DOCK',
    description: 'Cross Dock',
    fixedTimeInSec: 964,
    variableTimePerUnitOfMeasureInSecBox: 5,
    variableTimePerUnitOfMeasureInSecPallet: 964,
    IDK: 3,
  },
  {
    type: 'WAREHOUSE',
    description: 'Warehouse',
    fixedTimeInSec: 548,
    variableTimePerUnitOfMeasureInSecBox: 3,
    variableTimePerUnitOfMeasureInSecPallet: 548,
    IDK: 2,
  },
  {
    type: 'DISTRIBUTION_CENTER',
    description: 'Distribution Center',
    fixedTimeInSec: 548,
    variableTimePerUnitOfMeasureInSecBox: 3,
    variableTimePerUnitOfMeasureInSecPallet: 548,
    IDK: 2,
  },
];

export const STRATEGY_TYPES = [
  {
    type: 'FTL',
    description: 'FTL',
  },
  {
    type: 'LTL',
    description: 'LTL',
  },
];

export const SHIPPING_OPTIONS = [
  {
    type: 'SOLO',
    description: 'Solo',
  },
  {
    type: 'Shared',
    description: 'Shared',
  },
];

export const ACCOUNT_TYPES = {
  LOADING: [
    {
      type: 'DEFAULT',
      description: 'Default',
    },
    {
      type: 'DEFAULT-LTL',
      description: 'Default LTL',
    },
    {
      type: 'DEFAULT-TL',
      description: 'Default TL',
    },
    {
      type: 'BROKER-LTL',
      description: 'Broker LTL',
    },
  ],
  UNLOADING: [
    {
      type: 'DEFAULT',
      description: 'Default',
    },
    {
      type: 'DEFAULT-LTL',
      description: 'Default LTL',
    },
    {
      type: 'DEFAULT-TL',
      description: 'Default TL',
    },
  ],
  RELOADING: [
    {
      type: 'DEFAULT',
      description: 'Default',
    },
    {
      type: 'DEFAULT-LTL',
      description: 'Default LTL',
    },
    {
      type: 'DEFAULT-TL',
      description: 'Default TL',
    },
  ],
};

export const customer_types = [
  { description: 'Key Accounts _ No PO Required', type: '10-NP', customer: 'Key Accounts' },
  { description: 'Key Accounts _ Original PO Req', type: '10-OP', customer: 'Key Accounts' },
  { description: 'Key Accounts _ PO Required', type: '10-PR', customer: 'Key Accounts' },
  { description: 'Retail _ No PO Required', type: '11-NP', customer: 'Retail' },
  { description: 'Retail _ Original PO Required', type: '11-OP', customer: 'Retail' },
  { description: 'Retail _ PO Required', type: '11-PR', customer: 'Retail' },
  { description: 'WholeSale _ No PO Required', type: '12-NP', customer: 'WholeSale' },
  { description: 'WholeSale _ PO Required', type: '12-PR', customer: 'WholeSale' },
  { description: 'Van _ No PO Required', type: '13-NP', customer: 'Van' },
  { description: 'Pharmacy _ No PO Required', type: '14-NP', customer: 'Pharmacy' },
  { description: 'Pharmacy _ PO Required', type: '14-PR', customer: 'Pharmacy' },
  { description: 'Sub-D _ No PO Required', type: '15-NP', customer: 'Sub-D ' },
  { description: 'Sub-D _ PO Required', type: '15-PR', customer: 'Sub-D ' },
  { description: 'Presell _ No PO Required', type: '16-NP', customer: 'Presell' },
  { description: 'Presell _ PO Required', type: '16-PR', customer: 'Presell' },
  { description: 'Food Service - No PO Required', type: '17-NP', customer: 'Food Service' },
  { description: 'Medical _ No PO Required', type: '1M-NP', customer: 'Medical' },
];

export const OPERATION_TYPES = {
  FACILITY: [
    {
      type: 'PICKUP',
      description: 'Pickup',
    },
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
    {
      type: 'CASH_DEPOSIT',
      description: 'Cash Deposit',
    },
  ],
  CUSTOMER: [
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
  ],
  CONSTRUCTION_SITE: [
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
  ],
  WAITING_POINT: [
    {
      type: 'WAITING',
      description: 'Waiting',
    },
    {
      type: 'REST',
      description: 'Rest',
    },
  ],
  PLANT: [
    {
      type: 'PICKUP',
      description: 'Pickup',
    },
  ],
  CROSS_DOCK: [
    {
      type: 'PICKUP',
      description: 'Pickup',
    },
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
  ],
  WAREHOUSE: [
    {
      type: 'PICKUP',
      description: 'Pickup',
    },
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
    {
      type: 'CASH_DEPOSIT',
      description: 'Cash Deposit',
    },
  ],
  DISTRIBUTION_CENTER: [
    {
      type: 'PICKUP',
      description: 'Pickup',
    },
    {
      type: 'DROP_OFF',
      description: 'Dropoff',
    },
  ],
};

export const ALLOWED_MIME_TYPES = ['.jpeg', '.png', '.gif', '.jpg'].join(', ');
export const SEARCH_FOR_ADDRESSES_ENDPOINT = '/api/address/v3/search';
export const CREATE_NEW_ZONE_FORM = 'CREATE_NEW_ZONE';
export const ZONE_TYPES = [
  { value: 'DeliveryZone', description: ' Delivery Zone' },
  { value: 'BanZone', description: 'Ban Zone' },
];
